// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tls2h","centerX":"_3y5GV","centerY":"_1EXRz","centerXY":"_2GFif"};